<template>
    <div>
        {{ row.performances }}
        <span class="subtext">{{ row.previews }}</span>
    </div>
</template>

<script>
export default {
    props: ['row'],
};
</script>
